export interface NewPlanningOptions {
  fromShowId: number
  date: moment.Moment | null
  artist: server.dto.ArtistSmall
}

export const defaultNewPlanningOptions: NewPlanningOptions = {
  fromShowId: null,
  date: null,
  artist: null
}